// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aligns with home/profile sky gradient: #83bbf4 → #e0e7ee */
:root {
  --nav-bar-bg: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.58) 0%,
    rgba(225, 236, 245, 0.82) 100%
  );
  --nav-bar-border: rgba(21, 52, 72, 0.1);
  --nav-accent: #1e5278;
  --nav-accent-hover: #164565;
  --nav-text: #153448;
  /*
    Top of scrollable content below the fixed navbar.
    = top padding + content row + bottom padding + border + comfortable gap.
    Uses max() so wrapped/tall nav rows never leave content tucked under the bar.
  */
  --navbar-offset: max(
    7.25rem,
    calc(
      max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem
    )
  );
}

body {
  margin: 0;
}

div.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Match the row math used in --navbar-offset (content + vertical padding + border) */
  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px);
  background: var(--nav-bar-bg);
  backdrop-filter: blur(14px) saturate(1.15);
  -webkit-backdrop-filter: blur(14px) saturate(1.15);
  padding: max(10px, env(safe-area-inset-top, 0px)) 20px 12px;
  padding-left: max(20px, env(safe-area-inset-left, 0px));
  padding-right: max(20px, env(safe-area-inset-right, 0px));
  border-bottom: 1px solid var(--nav-bar-border);
  box-shadow: 0 4px 24px rgba(21, 52, 72, 0.06);
  border-radius: 0;
}

.navbar-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: clamp(0.35rem, 2vw, 0.75rem);
  min-width: 0;
}

.navbar-logo {
  height: clamp(40px, 10vw, 56px);
  width: auto;
  max-width: min(120px, 28vw);
  object-fit: contain;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.72);
  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.06);
  display: inline-block;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.navbar-logo:hover {
  box-shadow: 0 4px 12px rgba(21, 52, 72, 0.1);
}

.navbar-logo--secondary {
  max-width: min(88px, 24vw);
  height: clamp(36px, 9vw, 52px);
}

.navbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: clamp(0.45rem, 1.5vw, 0.75rem);
  margin-right: clamp(0.25rem, 2vw, 2rem);
  min-width: 0;
  flex: 1 1;
}

.nav-button {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  font-size: clamp(0.8125rem, 2vw, 0.9375rem);
  font-weight: 600;
  color: var(--nav-text);
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(30, 82, 120, 0.18);
  border-radius: 10px;
  cursor: pointer;
  gap: 0.4rem;
  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease,
    transform 0.15s ease;
  margin-right: 0;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);
}

.nav-button:hover {
  background: #fff;
  border-color: rgba(30, 82, 120, 0.28);
  box-shadow: 0 6px 20px rgba(21, 52, 72, 0.1);
  transform: translateY(-1px);
}

.nav-button:active {
  transform: translateY(0);
}

.nav-button:not(.logout) {
  color: var(--nav-accent);
}

.nav-button:not(.logout):hover {
  color: var(--nav-accent-hover);
}

.nav-button.logout {
  background-color: rgba(184, 92, 92, 0.12);
  color: #8f3a3a;
  border-color: rgba(184, 92, 92, 0.25);
}

.nav-button.logout:hover {
  background-color: rgba(184, 92, 92, 0.18);
  color: #7a3030;
}

.navbar-avatar-btn {
  margin-left: 0.15rem;
  border-radius: 50% !important;
  transition: background 0.2s ease, box-shadow 0.2s ease !important;
}

.navbar-avatar-btn:hover {
  background-color: rgba(255, 255, 255, 0.55) !important;
  box-shadow: 0 0 0 3px rgba(30, 82, 120, 0.12);
}

@media (max-width: 480px) {
  .nav-button {
    white-space: normal;
    text-align: center;
    max-width: 9rem;
  }
}

.main-content {
  padding-top: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/navbar_landingpage.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE;;;;GAIC;EACD,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB;;;;GAIC;EACD;;;;;GAKC;AACH;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qFAAqF;EACrF,iGAAiG;EACjG,6BAA6B;EAC7B,0CAA0C;EAC1C,kDAAkD;EAClD,2DAA2D;EAC3D,uDAAuD;EACvD,yDAAyD;EACzD,8CAA8C;EAC9C,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,4CAA4C;EAC5C,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mCAAmC;EACnC,uCAAuC;EACvC,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX;wBACsB;EACtB,eAAe;EACf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,iEAAiE;AACnE;;AAEA;EACE,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Aligns with home/profile sky gradient: #83bbf4 → #e0e7ee */\n:root {\n  --nav-bar-bg: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.58) 0%,\n    rgba(225, 236, 245, 0.82) 100%\n  );\n  --nav-bar-border: rgba(21, 52, 72, 0.1);\n  --nav-accent: #1e5278;\n  --nav-accent-hover: #164565;\n  --nav-text: #153448;\n  /*\n    Top of scrollable content below the fixed navbar.\n    = top padding + content row + bottom padding + border + comfortable gap.\n    Uses max() so wrapped/tall nav rows never leave content tucked under the bar.\n  */\n  --navbar-offset: max(\n    7.25rem,\n    calc(\n      max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem\n    )\n  );\n}\n\nbody {\n  margin: 0;\n}\n\ndiv.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* Match the row math used in --navbar-offset (content + vertical padding + border) */\n  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px);\n  background: var(--nav-bar-bg);\n  backdrop-filter: blur(14px) saturate(1.15);\n  -webkit-backdrop-filter: blur(14px) saturate(1.15);\n  padding: max(10px, env(safe-area-inset-top, 0px)) 20px 12px;\n  padding-left: max(20px, env(safe-area-inset-left, 0px));\n  padding-right: max(20px, env(safe-area-inset-right, 0px));\n  border-bottom: 1px solid var(--nav-bar-border);\n  box-shadow: 0 4px 24px rgba(21, 52, 72, 0.06);\n  border-radius: 0;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  gap: clamp(0.35rem, 2vw, 0.75rem);\n  min-width: 0;\n}\n\n.navbar-logo {\n  height: clamp(40px, 10vw, 56px);\n  width: auto;\n  max-width: min(120px, 28vw);\n  object-fit: contain;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 0.72);\n  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.06);\n  display: inline-block;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.navbar-logo:hover {\n  box-shadow: 0 4px 12px rgba(21, 52, 72, 0.1);\n}\n\n.navbar-logo--secondary {\n  max-width: min(88px, 24vw);\n  height: clamp(36px, 9vw, 52px);\n}\n\n.navbar-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: clamp(0.45rem, 1.5vw, 0.75rem);\n  margin-right: clamp(0.25rem, 2vw, 2rem);\n  min-width: 0;\n  flex: 1;\n}\n\n.nav-button {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  font-size: clamp(0.8125rem, 2vw, 0.9375rem);\n  font-weight: 600;\n  color: var(--nav-text);\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(30, 82, 120, 0.18);\n  border-radius: 10px;\n  cursor: pointer;\n  gap: 0.4rem;\n  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease,\n    transform 0.15s ease;\n  margin-right: 0;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);\n}\n\n.nav-button:hover {\n  background: #fff;\n  border-color: rgba(30, 82, 120, 0.28);\n  box-shadow: 0 6px 20px rgba(21, 52, 72, 0.1);\n  transform: translateY(-1px);\n}\n\n.nav-button:active {\n  transform: translateY(0);\n}\n\n.nav-button:not(.logout) {\n  color: var(--nav-accent);\n}\n\n.nav-button:not(.logout):hover {\n  color: var(--nav-accent-hover);\n}\n\n.nav-button.logout {\n  background-color: rgba(184, 92, 92, 0.12);\n  color: #8f3a3a;\n  border-color: rgba(184, 92, 92, 0.25);\n}\n\n.nav-button.logout:hover {\n  background-color: rgba(184, 92, 92, 0.18);\n  color: #7a3030;\n}\n\n.navbar-avatar-btn {\n  margin-left: 0.15rem;\n  border-radius: 50% !important;\n  transition: background 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.navbar-avatar-btn:hover {\n  background-color: rgba(255, 255, 255, 0.55) !important;\n  box-shadow: 0 0 0 3px rgba(30, 82, 120, 0.12);\n}\n\n@media (max-width: 480px) {\n  .nav-button {\n    white-space: normal;\n    text-align: center;\n    max-width: 9rem;\n  }\n}\n\n.main-content {\n  padding-top: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
